import { render, staticRenderFns } from "./HousingCompanyNotAvailableView.vue?vue&type=template&id=7a292092&"
import script from "./HousingCompanyNotAvailableView.vue?vue&type=script&lang=ts&"
export * from "./HousingCompanyNotAvailableView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports